// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.refer-input-pc-box .ynf-refer-popover {
  padding-top: 0;
}
.refer-input-pc-box .ynf-refer-popover .wui-popover-arrow-content {
  display: none;
}
.yyrefer-popover-btn {
  padding: 8px 11px;
  border-top: solid 1px #D9D9D9;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  -webkit-align-items: center;
          align-items: center;
}
.yyrefer-popover-btn .cancel {
  margin-right: 6px;
}
.refer-dropdown-box {
  max-height: 350px;
  overflow: auto;
  padding: 8px 0;
}
.refer-dropdown-box .list-item {
  height: 32px;
  padding: 0 12px;
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: space-between;
          justify-content: space-between;
  -webkit-align-items: center;
          align-items: center;
  font-size: 12px;
  color: #111;
  cursor: pointer;
}
.refer-dropdown-box .list-item:hover {
  background: #F0F0F0;
}
.refer-dropdown-box .list-item .uf-correct-2 {
  font-size: 10px;
  font-weight: bold;
  color: #EE2223;
}
.refer-dropdown-box .loading {
  font-size: 12px;
  color: #999;
  padding: 0 12px;
}
`, "",{"version":3,"sources":["webpack://./src/components/ReferInputPcNew/components/DropDown/index.less"],"names":[],"mappings":"AACA;EAEI,cAAA;AADJ;AADA;EAIM,aAAA;AAAN;AAIA;EACE,iBAAA;EACA,6BAAA;EACA,qBAAA;EAAA,aAAA;EACA,sCAAA;UAAA,8BAAA;EACA,2BAAA;UAAA,mBAAA;AAFF;AAHA;EAQM,iBAAA;AAFN;AAcA;EACE,iBAAA;EACA,cAAA;EACA,cAAA;AAZF;AASA;EAMI,YAAA;EACA,eAAA;EACA,qBAAA;EAAA,aAAA;EACA,sCAAA;UAAA,8BAAA;EACA,2BAAA;UAAA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAJA;EAoBM,eAAA;EACA,iBAAA;EACA,cAAA;AAbN;AATA;EA2BI,eAAA;EACA,WAAA;EACA,eAAA;AAfJ","sourcesContent":["\n.refer-input-pc-box {\n  .ynf-refer-popover {\n    padding-top: 0;\n    .wui-popover-arrow-content {\n      display: none;\n    }\n  }\n}\n.yyrefer-popover-btn {\n  padding: 8px 11px;\n  border-top: solid 1px #D9D9D9;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .cancel {\n      margin-right: 6px;\n  }\n}\n\n// .search-open {\n//   text-align: right;\n//   color: #0033cc;\n//   cursor: pointer;\n//   font-size: 12px;\n//   margin-right: 16px;\n// }\n\n.refer-dropdown-box {\n  max-height: 350px;\n  overflow: auto;\n  padding: 8px 0;\n\n  .list-item {\n    height: 32px;\n    padding: 0 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n    color: #111;\n    cursor: pointer;\n    \n    &:hover {\n      background: #F0F0F0;\n    }\n\n    .uf-correct-2 {\n      font-size: 10px;\n      font-weight: bold;\n      color: #EE2223;\n    }\n  }\n\n  .loading {\n    font-size: 12px;\n    color: #999;\n    padding: 0 12px;\n  }\n\n//   //滚动条整体部分\n//   &::-webkit-scrollbar {\n//     width: 8px;\n//   }\n\n//   //滚动条两端的按钮\n//   &::-webkit-scrollbar-button {\n\n//   }\n\n//   // 外层轨道\n//   &::-webkit-scrollbar-track {}\n\n//   //内层轨道，滚动条中间部分（除去）\n//   &::-webkit-scrollbar-track-piece {\n    \n//   }\n\n//   //滚动条里面可以拖动的那个\n//   &::-webkit-scrollbar-thumb {\n//     width: 8px;\n//     height: 121px;\n//     background: #CDD9E6;\n//     border-radius: 4px;\n//   }\n\n//   //边角\n//   &::-webkit-scrollbar-corner {}\n\n//   //定义右下角拖动块的样式\n//   &::-webkit-resizer {}\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
